<template>
  <div :class="{vertical: data.vertical}" class="chances-risks">
    <table class="chances">
      <thead>
      <tr>
        <th colspan="2">
          <h3>{{ _.get(data, 'chancesLabel', 'Chancen') }}</h3>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(chance, key) in data.chances" :key="key">
        <td><i class="fa fa-check"></i></td>
        <td v-html="chance"></td>
      </tr>
      </tbody>

    </table>
    <table class="risks">
      <thead>
      <tr>
        <th colspan="2">
          <h3>{{ _.get(data, 'riskLabel', 'Risiken') }}</h3>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(risk, key) in data.risks" :key="key">
        <td><i class="fa fa-exclamation-circle"></i></td>
        <td v-html="risk"></td>
      </tr>
      </tbody>

    </table>
  </div>
</template>

<script>
export default {
  name: 'chances-risks',
  props: {
    'data': {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// BlockChancesRisks.vue?656b39a6